/** Lien envoyé par les mails de relance d'impayé (Brevo), à garder tel quel : des mails sont déjà partis. */
export const BILLING_REGULARIZATION_PATH = '/billing/regularization';

/** Marqueur d'historique qui demande l'ouverture de la modale d'impayé à l'arrivée sur Facturation. */
export const OPEN_UNPAID_MODAL_STATE = 'openUnpaidModal';

export function parseRegularizationWorkspaceId(search: string): number | null {
  const raw = new URLSearchParams(search).get('workspaceId');
  if (raw === null || !/^\d+$/.test(raw.trim())) return null;
  const workspaceId = Number(raw.trim());
  return Number.isSafeInteger(workspaceId) && workspaceId > 0 ? workspaceId : null;
}

export function isUnpaidModalRequested(state: unknown): boolean {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as Record<string, unknown>)[OPEN_UNPAID_MODAL_STATE] === true
  );
}
